module.exports = __webpack_public_path__ + "img/entrance.68225493.svg";